import { render } from "./OrderdetailMobile.vue?vue&type=template&id=04e0fe30&scoped=true"
import script from "./OrderdetailMobile.vue?vue&type=script&lang=js"
export * from "./OrderdetailMobile.vue?vue&type=script&lang=js"

import "./OrderdetailMobile.vue?vue&type=style&index=0&id=04e0fe30&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e0fe30"]])

export default __exports__